import { useEffect } from "react";
import type { Lang } from "../lib/types";
import Logo from "./Logo";

// 스플래시 — 달빛에서 떠오르는 워드마크. 짧게 보여주고 홈으로.
export default function Splash({ lang, onDone }: { lang: Lang; onDone: () => void }) {
  useEffect(() => {
    const id = setTimeout(onDone, 1400);
    return () => clearTimeout(id);
  }, [onDone]);

  return (
    <div className="screen splash" onClick={onDone}>
      <Logo size={64} lang={lang} />
    </div>
  );
}
